module.exports = __webpack_public_path__ + "img/btn.9ed0403a.png";